import { ChangeDetectorRef, Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { addMonths, endOfDay, startOfDay } from 'date-fns';
import { ConfirmEventType } from 'primeng/api';
import { Table } from 'primeng/table';
import { CodeConverter } from 'server/entity/code-converter';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { DoMerge } from 'src/app/core/enums/do-merge.enum';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { LaasOption } from 'src/app/core/models/laas-option';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { PageInfo } from 'src/app/core/models/page-info';
import { DoMergeSearchResult } from 'src/app/core/models/transport-operation/do-merge-search-result';
import { MergeBlockDetailResult, MergeContactInfo } from 'src/app/core/models/transport-operation/merge-block-detail-result';
import { MergedDeliveryOrderRequest } from 'src/app/core/models/transport-operation/merged-delivery-order-request';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { NotificationSubScriptionService } from 'src/app/core/services/notification-sub-scription.service';
import { addDays, deepCopy, getDataScopeByPermission, isNullOrEmpty, laaSFormatString } from 'src/app/core/utils/common-functions';
import { copyFormControl } from 'src/app/core/utils/validation-functions';
import { AddressMaintainanceService } from 'src/app/features/setting/service/address-maintainance.service';
import { DeliveryOrderService } from 'src/app/features/transport-operation/services/delivery-order.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { ForwarderService } from '../../services/forwarder.service';
import { MergeKeyService } from '../../services/merge-key.service';
import { FacilityService } from './../../../../core/services/facility.service';
import { mergeDoInfoRequest } from './interface/changDoTaskCodeRequest';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { OrderQueryScopeEnum } from 'src/app/core/enums/order-query-scope.enum';

@Component({
  selector: 'laas-do-merge',
  templateUrl: './do-merge.component.html',
  styleUrls: ['./do-merge.component.scss']
})
export class DoMergeComponent extends SessionBaseComponent implements OnInit {

  @Input() doMergeType!: DoMerge;

  readonly permissionCode: PermissionConstants = PermissionConstants.ViewMergeKeySearch;
  readonly preferenceKey: string = UserPreferenceConstants.DoMergeSearch;
  protected readonly OrderQueryScopeEnum = OrderQueryScopeEnum;

  orderQueryScope: OrderQueryScopeEnum = this.OrderQueryScopeEnum.personal;
  isSearchFormOpen: boolean = true;
  searchForm!: FormGroup;
  defaultEtdDt: Date[];
  etdMinDate: Date = new Date(0);
  letterHeadOrgIdOptions: LaasOption[] = [];
  consigneeKeyOptionsMapping: LaasOption[] = [];
  doStatusOptions: LaasOption[] = [];
  facilityOptions: LaasOption[] = [];
  dropOptions: LaasOption[] = [];
  deliveryCategoryOptions: LaasOption[] = [];
  allShipToOptions: any[] = [];
  shipToOptions: LaasOption[] = [];
  createrOptions: LaasOption[] = [];
  salesOptions: LaasOption[] = [];
  commonOptions: any = [];
  hasBookingOptions: LaasOption[] = [];
  selectedRows: DoMergeSearchResult[] = [];
  pageInfo: PageInfo;
  sortInfo: { property: string, direction: number } | null;
  results: DoMergeSearchResult[] = [];
  dataTableColumns: DateTableColumn[] = [];
  serchParams: MergedDeliveryOrderRequest = new MergedDeliveryOrderRequest();
  @Output() mergeDoEvent = new EventEmitter<DoMergeSearchResult[]>();
  @Output() importDoEvent = new EventEmitter<DoMergeSearchResult[]>();

  consigneeKeyOptions: LaasOption[] = [];
  queryFlag: boolean = true;
  recordParams:any;
  MergeTaskCodeOptions: LaasOption[] = [];

  isLoading:boolean = false;
  headerChecked: boolean;

  selectedRowsWithCheckBox: DoMergeSearchResult[];
  @ViewChild('doMergeTable') table!: Table;

  selectedTableColumns:DateTableColumn[] = [];

  editMode: boolean;

  selectedEditRow: DoMergeSearchResult | null;
  previousSelectedEditRow: DoMergeSearchResult | null;


  cloneTableResults : DoMergeSearchResult[];

  @ViewChild('etdDt') etdDt!: CalendarComponent;

  forwarderOptions: Array<LaasOption> = [];
  erpforwarderOptions: any[] = [];
  filterForwarderOptions: Array<LaasOption> = [];

  // 勾選 DO 之出貨合計
  summary: {
    cartonCnt: string;
    totalNetWeight: string;
    totalGrossWeight: string;
    volumeWeight: string;
    cbm: string;
    pieces: string;
    price: string;
    currencyCode: string;
  } = { cartonCnt: '', totalNetWeight: '', totalGrossWeight: '', volumeWeight: '', cbm: '', pieces: '', price: '', currencyCode: '' };
  isSameCurrencyCode: boolean = true;
  hasMissing: boolean = false;
  missingTooltip: string = '';

  isShowBlockDialog: boolean = false;
  blockDetail: MergeBlockDetailResult | null = null;

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private facilityService: FacilityService,
    private addressMaintainanceService: AddressMaintainanceService,
    private commonDataService: CommonDataService,
    private deliveryOrderService: DeliveryOrderService,
    private mergeKeyService: MergeKeyService,
    private dropdownOptionService: DropdownOptionsService,
    private notificationSubScriptionService:NotificationSubScriptionService,
    private changeDetector: ChangeDetectorRef,
    private forwarderService: ForwarderService
  ) {
    super(injector);

    this.pageInfo = { pageSize: 5, pageIndex: 0, totalRecords: 0, totalPages: 0 };
    const dataTablePreference = this.getDataTablePreference(this.preferenceKey);
    this.sortInfo = isNullOrEmpty(dataTablePreference?.state?.sortField) || isNullOrEmpty(dataTablePreference?.state?.sortOrder) ? null :
      { property: dataTablePreference?.state?.sortField, direction: dataTablePreference?.state?.sortOrder };

    this.dataTableColumns = this.headerTableTranslation();

    this.defaultEtdDt = [startOfDay(addDays(new Date(), -7)), endOfDay(addDays(new Date(), 7))];

    this.searchForm = this.fb.group({
      orderQueryScope: [this.OrderQueryScopeEnum.all, Validators.required],
      doNos: [],
      letterHeadOrgId: null,
      consigneeKey: [],
      doStatus: [],
      facility: null,
      etdDtStart: [startOfDay(addDays(new Date(), -7))],
      etdDtEnd: [endOfDay(addDays(new Date(), 7))],
      deliveryCategory: null,
      dropType: null,
      hasBooking: '0',
      creater: [],
      sales: [],
      shipTo: []
    });

    this.recordParams = {
      consigneeKey: [],
      consigneeCompany: null
    }

    this.headerChecked = false;

    this.editMode = false;

    this.selectedEditRow = null;
    this.previousSelectedEditRow = null;
    this.selectedRowsWithCheckBox = [];
    this.cloneTableResults = [];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.commonOptions = [
      { label: 'Y', value: '1' },
      { label: 'N', value: '0' }
    ];
    this.buildHasBookingOptions();

    this.facilityService.getTenantOrgOptions().subscribe({
      next: (options: any[]) => {
        this.letterHeadOrgIdOptions = options.map(x => ({ label: `${x.orgId} - ${x.orgName}`, value: x.orgId}));
      }
    });

    this.addressMaintainanceService.getCustomerOptions().subscribe({
      next: (result) => {
        this.consigneeKeyOptionsMapping = [...result].map((x: any) => {
          return {
            label: `${x.customerCode} - ${x.customerName}`,
            value: x.customerCode,
          };
        });
      },
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "DoStatus").subscribe({
      next: (options: CodeConverter[]) => {
        this.doStatusOptions = options.map(x => ({label: `${x.codeKey ?? ""} - ${x.codeDesc ?? ""}` , value:x.codeKey ?? ""}))
      }
    });

    this.deliveryOrderService.getFacilityOptions().subscribe({
      next: (options: FacilityOptions[]) => {
        this.facilityOptions = options.map(x => ({label: `${x.optionCode} - ${x.optionDesc}`, value:x.optionCode}))
      }
    });

    this.dropdownOptionService.getDeliveryTypeOptions(false)
      .subscribe({
        next: (options: any[]) => {
          this.deliveryCategoryOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    let dropYesOption = await this.translateService.get("DoMerge.Options.Drop.Yes").toPromise();
    let dropNoOption = await this.translateService.get("DoMerge.Options.Drop.No").toPromise();

    this.dropOptions = [{
      label: dropYesOption,
      value: "1"
    },{
      label: dropNoOption,
      value: "0"
    }];

    this.dropdownOptionService.getCsrOptions().subscribe({
      next: (options: any[]) => {
        this.createrOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionService.getSalesOptions().subscribe({
      next: (options: any[]) => {
        this.salesOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "MergeTaskCode").subscribe({
      next: (options: CodeConverter[]) => {
        this.MergeTaskCodeOptions = options.map(x => ({ label: `${x.codeKey ?? ""} - ${x.codeDesc ?? ""}`, value: x.codeKey ?? "" }))
        this.MergeTaskCodeOptions.unshift({
          label: '-',
          value: ""
        })
      }
    });

    this.selectedColumns = this.dataTableColumns;

    this.forwarderService.getErpForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.erpforwarderOptions = options;
      },
    });

    this.forwarderService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options.map((x) => ({
          label: `${x.text}`.replace(' ', ' - '),
          value: x.value,
        }));
      }
    });
  }

  // 是否已建立派車：ALL=不限、1=已建立(Y)、0=未建立(N)
  buildHasBookingOptions(): void {
    this.hasBookingOptions = [
      { label: this.translateService.instant('DoMerge.Search.All'), value: 'ALL' },
      { label: 'Y', value: '1' },
      { label: 'N', value: '0' }
    ];
  }

  async setPageSize(event: any): Promise<void>{
    this.pageInfo.pageSize = event.rows;
  }

  tablePageChange(event: any): void {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.getMergedDeliveryOrderResults();
  }

  tableSort(event: any): void {
    this.sortInfo = { property: event.field, direction: event.order };
    this.pageInfo.pageIndex = 0;
    this.getMergedDeliveryOrderResults();
  }

  searchClickBtn(event: Event): void{
    if (this.searchForm.invalid || this.customValidator(this.searchForm)) {
      this.searchForm.markAllAsTouched();
      this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFields'));
      return;
    }

    this.serchParams = copyFormControl(this.searchForm, this.serchParams);
    this.isSearchFormOpen = false;
    this.pageInfo.pageIndex = 0;
    // 查詢時清空勾選並重置合計
    this.selectedRowsWithCheckBox = [];
    this.resetSummary();
    this.getMergedDeliveryOrderResults();
  }

  openBlockDetailDialog(row: DoMergeSearchResult): void {
    if (isNullOrEmpty(row.doNo)) {
      return;
    }
    this.mergeKeyService.getMergeBlockDetail(row.doNo!).subscribe({
      next: detail => {
        this.blockDetail = {
          ...detail,
          contacts: this.normalizeMergeContacts(detail.contacts)
        };
        this.isShowBlockDialog = true;
      }
    });
  }

  closeBlockDialog() {
    this.isShowBlockDialog = false;
    this.blockDetail = null;
  }

  contactPrimaryWindow(): void {
    this.openTeamsChat(this.getPrimaryContacts());
  }

  contactProxyWindow(): void {
    this.openTeamsChat(this.getProxyContacts());
  }

  private openTeamsChat(contacts: MergeContactInfo[]): void {
    const users = contacts
      .map(contact => this.getContactEmail(contact))
      .filter((email): email is string => !isNullOrEmpty(email))
      .map(email => encodeURIComponent(email))
      .join(',');

    if (isNullOrEmpty(users)) {
      return;
    }
    const message = encodeURIComponent(this.buildTeamsMessage());
    window.open('msteams://teams.microsoft.com/l/chat/0/0?users=' + users + '&message=' + message, '_blank');
  }

  private buildTeamsMessage(): string {
    return [
      `${this.translateService.instant('DoMerge.BlockDialog.MergeKey')} : ${this.blockDetail?.mergeKey ?? ''}`,
      `${this.translateService.instant('DoMerge.MainTable.DoNo')} : ${this.blockDetail?.doNo ?? ''}`,
      `${this.translateService.instant('DoMerge.MainTable.Facility')} : ${this.blockDetail?.facility ?? ''}`
    ].join('\r\n');
  }

  getBlockReasonTranslationKey(reasonCode: string): string {
    return `DoMerge.BlockReason.${reasonCode}`;
  }


  hasBlockReason(reasonCode: string): boolean {
    return this.blockDetail?.blockReasonCodes?.includes(reasonCode) ?? false;
  }

  getOtherBlockReasonCodes(): string[] {
    return (this.blockDetail?.blockReasonCodes ?? [])
      .filter(reasonCode => !['MRG0001', 'MRG0004'].includes(reasonCode));
  }
  getPrimaryContacts(): MergeContactInfo[] {
    const contacts = this.blockDetail?.contacts ?? [];
    return contacts.filter(contact => this.isPrimaryContact(contact));
  }
  
  getProxyContacts(): MergeContactInfo[] {
    const contacts = this.blockDetail?.contacts ?? [];
    return contacts.filter(contact => this.isProxyContact(contact));
  }

  hasPrimaryContact(): boolean {
    return this.getPrimaryContacts().length > 0;
  }

  private isPrimaryContact(contact: MergeContactInfo): boolean {
    return contact.setupValue2 === 'PRIMARY';
  }

  private isProxyContact(contact: MergeContactInfo): boolean {
    return contact.setupValue2 === 'PROXY';
  }

  getContactName(contact: MergeContactInfo | null): string {
    return contact?.setupValueDesc ?? contact?.setupValue ?? '-';
  }

  getContactEmail(contact: MergeContactInfo | null): string | null {
    return contact?.email ?? null;
  }

  getContactNames(contacts: MergeContactInfo[]): string {
    return contacts.map(contact => this.getContactName(contact)).filter(name => name !== '-').join(', ');
  }

  shouldShowContactNames(contacts: MergeContactInfo[]): boolean {
    return !contacts.some(contact => this.isProxyAsPrimaryContact(contact));
  }

  hasPrimaryContactEmail(): boolean {
    return this.hasContactEmail(this.getPrimaryContacts());
  }

  hasProxyContactEmail(): boolean {
    return this.hasContactEmail(this.getProxyContacts());
  }

  private hasContactEmail(contacts: MergeContactInfo[]): boolean {
    return contacts.some(contact => !isNullOrEmpty(this.getContactEmail(contact)));
  }

  private isProxyAsPrimaryContact(contact: MergeContactInfo): boolean {
    return this.isPrimaryContact(contact) && contact.sourceSetupValue2 === 'PROXY';
  }

  private normalizeMergeContacts(contacts: MergeContactInfo[] | null): MergeContactInfo[] {
    return (contacts ?? [])
      .map(contact => ({
        ...contact,
        setupValue: contact.setupValue,
        setupValueDesc: contact.setupValueDesc,
        setupValue2: contact.setupValue2,
        sourceSetupValue2: contact.sourceSetupValue2 ?? contact.setupValue2,
        email: contact.email
      }))
      .filter(contact => !isNullOrEmpty(contact.email));
  }
  
  resetClickBtn(event: Event): void{
    this.defaultEtdDt = [startOfDay(addDays(new Date(), -7)), endOfDay(addDays(new Date(), 7))];
    this.etdDt.ngOnInit();
    this.searchForm.reset({
      orderQueryScope: this.OrderQueryScopeEnum.all,
      hasBooking: '0',
      etdDtStart: this.defaultEtdDt[0],
      etdDtEnd: this.defaultEtdDt[1]
    });
  }

  chipsAdd(event: any, fromControlName: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').map(x => x.trim()).filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    const formControl = this.searchForm.get(fromControlName);
    formControl?.value.splice(formControl?.value.indexOf(value));
    formControl?.setValue(formControl?.value.concat(parsedValues));
  }

  getMergedDeliveryOrderResults(): void{
    this.headerChecked = false;
    this.selectedRowsWithCheckBox = [];
    this.editMode = false;
    this.isLoading = true;

    var dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
    this.serchParams.dataScopes = dataScopes;
    this.serchParams.pageIndex = this.pageInfo.pageIndex;
    this.serchParams.pageSize = this.pageInfo.pageSize;
    this.serchParams.sortInfo = isNullOrEmpty(this.sortInfo) ? null : [this.sortInfo];
    this.serchParams.createUserEmail = this.userProfile.email;
    this.serchParams.orderQueryScope = this.searchForm.value.orderQueryScope;

    this.mergeKeyService.queryMergedDeliveryOrder(this.serchParams).subscribe({
      next: pageResults => {
        this.results = pageResults.content;
        this.cloneTableResults = deepCopy(this.results)!;
        this.pageInfo.totalRecords = pageResults.totalElements;
        this.pageInfo.totalPages = pageResults.totalPages;
        this.table.cancelRowEdit(this.selectedEditRow);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  mergeDos(event: Event): void{
    this.mergeDoEvent.emit(this.selectedRowsWithCheckBox.filter(row => row.canMerge));
  }

  importDos(event: Event): void{
    this.importDoEvent.emit(this.selectedRowsWithCheckBox.filter(row => row.canMerge));
  }

  displayActionBtn(type: string): boolean{
    return this.doMergeType?.toString() === type;
  }

  resetComponent(event: Event): void{
    this.resetClickBtn(event);
    this.selectedRows = [];
    this.selectedRowsWithCheckBox = [];
    this.results = [];
    this.resetSummary();
  }

  getCustomerOptions(event: any) {
    const conText: string = event.filter;
    if (conText != null && conText.length > 0 && this.queryFlag) {
      this.queryFlag = false;
      this.notificationSubScriptionService.getCustomerOptionsByFilter(conText).subscribe({
        next: (options: any[]) => {
          this.consigneeKeyOptions = options.map<LaasOption>(x => ({
            label: x.customerCode + ' - ' + x.customerName,
            value: x.customerCode,
          }));
          this.changeDetector.detectChanges();
          this.queryFlag = true;
        }
      });

    }
  }

  customValidator(control: AbstractControl): ValidationErrors | null {
    const doNos = control.get('doNos')?.value;
    const etdDtStart = control.get('etdDtStart')?.value;
    if ((doNos == null || doNos.length === 0) && etdDtStart == null) {
      return { requiredFields: true };
    }
    return null;
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case 'etdDt':
        if (!date?.startDate) {
          this.searchForm.patchValue({
            etdDtStart: null,
            etdDtEnd: null
          });
          break;
        }

        const startDate = startOfDay(date.startDate);
        const maxEndDate = endOfDay(addMonths(startDate, 1));

        if (!date?.endDate) {
          this.searchForm.patchValue({
            etdDtStart: startDate,
            etdDtEnd: maxEndDate
          });
          break;
        }

        const endDate = endOfDay(date.endDate);

        if (endDate.getTime() > maxEndDate.getTime()) {
          const instantMsg = this.translateService.instant('Common.Message.DateRangeCannotExceedSeveralMonths');
          this.toastService.warn(`${laaSFormatString(instantMsg, ['1'])}\n`);
          this.etdDt.clearDate();
          this.searchForm.patchValue({
            etdDtStart: null,
            etdDtEnd: null
          });
          break;
        }

        this.searchForm.patchValue({
          etdDtStart: startDate,
          etdDtEnd: endDate
        });
        break;
    }
  }

  getBookingForwarderDisplay(info: any): string | null {
    if (isNullOrEmpty(info?.bookingForwarder)) {
      return null;
    }
    if (isNullOrEmpty(info?.bookingForwarderName)) {
      return info.bookingForwarder;
    }
    return `${info.bookingForwarder} - ${info.bookingForwarderName}`;
  }
  getShipToOptionsByConsigneeKey() {
    Object.assign(this.recordParams, this.searchForm.value);
    this.shipToOptions = [];
    this.searchForm.controls["shipTo"].setValue([]);
    if (this.recordParams.consigneeKey != null && this.recordParams.consigneeKey.length != 0) {
      let shipToParams = { consigneeKey: this.recordParams.consigneeKey };
      this.dropdownOptionService.getShipToOptionsByConsigneeKey(shipToParams).subscribe({
        next: (options: any[]) => {
          this.shipToOptions = options.map((x) => {
            return {
              label: x.optionDesc,
              value: x.optionCode
            };
          });
        }
      });
    }
  }

  switchEditMode() {
    if (this.editMode) {
      if (this.changeNotSaveConfirm()) {
        this.confirmationService.confirm({
          message: this.translateService.instant('DoMerge.Confirm.ChangeSaveOrNot'),
          header: this.translateService.instant('DoMerge.Confirm.Header'),
          icon: 'pi pi-info-circle',
          accept: () => {
            this.doTaskCodeSaveChange();
          },
          reject: (type: any) => {
            switch (type) {
              case ConfirmEventType.REJECT:
                break;
              case ConfirmEventType.CANCEL:
                break;
            }
          }
        })
      } else {
        this.table.cancelRowEdit(this.selectedEditRow);
        this.editMode = false;
      }
    } else {
      this.editMode = true;
      this.headerDoSwitchRow();
    }
  }

  headerDoSwitchRow(){
    this.table.cancelRowEdit(this.previousSelectedEditRow);

    this.table.initRowEdit(this.selectedEditRow);

    this.previousSelectedEditRow = deepCopy(this.selectedEditRow);
  }

  changeNotSaveConfirm(): boolean {
    if (this.editMode) {
      for (const rowVal of this.results) {
        for (const cloneRowVal of this.cloneTableResults) {
          if (rowVal.doNo == cloneRowVal.doNo) {
            if (JSON.stringify(rowVal) != JSON.stringify(cloneRowVal)) {
              return true;
            }
          }
        }
      }
      return false;
    } else {
      return false;
    }
  }

  saveBtnClick() {
    if (this.changeNotSaveConfirm()) {
      this.confirmationService.confirm({
        message: this.translateService.instant('DoMerge.Confirm.SaveOrNot'),
        header: this.translateService.instant('DoMerge.Confirm.Header'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.doTaskCodeSaveChange();
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              break;
            case ConfirmEventType.CANCEL:
              break;
          }
        }
      })
    } else {
      this.table.cancelRowEdit(this.selectedEditRow);
      this.editMode = false;
    }
  }

  selectAllOrUnSelectAll(event: any) {
    if (this.headerChecked) {
      this.selectedRowsWithCheckBox = this.results.filter(row => row.canMerge);
    } else {
      this.selectedRowsWithCheckBox = [];
    }
    this.onSelectionChange();
  }

  // 勾選變動時加總合計
  onSelectionChange(): void {
    const rows: any[] = this.selectedRowsWithCheckBox;

    if (rows.length === 0) {
      this.resetSummary();
      return;
    }

    const reducer = (accumulator: any, currentValue: any) => accumulator + currentValue;
    this.summary.cartonCnt = this.calculateTotalProperty(rows, 'cartonCnt', reducer, false);
    this.summary.totalNetWeight = this.calculateTotalProperty(rows, 'totalNetWeight', reducer, false);
    this.summary.totalGrossWeight = this.calculateTotalProperty(rows, 'totalGrossWeight', reducer, false);
    this.summary.volumeWeight = this.calculateTotalProperty(rows, 'volumeWeight', reducer, false);
    this.summary.cbm = this.calculateTotalProperty(rows, 'cbm', reducer, true); // 材積(CBM) 無條件進位 2 位
    this.summary.pieces = this.calculateTotalProperty(rows, 'pieces', reducer, false);
    this.summary.price = this.calculateTotalProperty(rows, 'price', reducer, false); // 金額僅同幣別顯示
    this.checkSameCurrencyCode(rows);
    this.collectMissingInfo(rows);
  }

  private resetSummary(): void {
    this.summary = { cartonCnt: '', totalNetWeight: '', totalGrossWeight: '', volumeWeight: '', cbm: '', pieces: '', price: '', currencyCode: '' };
    this.isSameCurrencyCode = true;
    this.hasMissing = false;
    this.missingTooltip = '';
  }

  //因為下面使用string來進行千分位格式轉換 所以回傳也要是string否則會顯示NaN（非空值加總）
  private calculateTotalProperty(rows: any[], property: string, reducer: any, isCeil: boolean): string {
    const sum = rows
      .filter(x => x[property] != null)
      .map(x => x[property])
      .reduce(reducer, 0);
    let formattedSum;
    if (Number.isInteger(sum)) {
      formattedSum = sum.toString();
    } else if (isCeil) {
      formattedSum = this.roundUp(sum, 2);
    } else {
      formattedSum = sum.toFixed(2);
    }
    return this.formatNumber(formattedSum);
  }

  private formatNumber(num: string): string {
    const parts = num.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  private roundUp(num: number, decimal: number): number {
    return Math.ceil((num + Number.EPSILON) * Math.pow(10, decimal)) / Math.pow(10, decimal);
  }

  // 金額僅同幣別顯示：處理方式沿用「出貨進度查詢」的 isCurrencyCode
  private checkSameCurrencyCode(rows: any[]): void {
    let referenceCurrencyCode: string | null = null;
    // 有些 DO 沒有發票，找第一個不是 null 的當參考值
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].currencyCode !== null) {
        referenceCurrencyCode = rows[i].currencyCode;
        break;
      }
    }

    // 如果所有都是 null => true
    if (referenceCurrencyCode === null) {
      this.isSameCurrencyCode = true;
      return;
    }

    const filteredRows = rows.filter(row => row.currencyCode !== null);
    if (filteredRows.every(row => row.currencyCode === referenceCurrencyCode)) {
      this.isSameCurrencyCode = true;
      this.summary.currencyCode = referenceCurrencyCode;
    } else {
      this.isSameCurrencyCode = false;
    }
  }

  // 缺漏提示：收集每筆缺（null）的欄位，供合計列旁的紅色驚嘆號 tooltip 顯示
  private collectMissingInfo(rows: any[]): void {
    const checkFields = [
      { key: 'totalNetWeight', label: this.translateService.instant('DOQuery.Form.Title.NetWeight') },
      { key: 'totalGrossWeight', label: this.translateService.instant('DOQuery.Form.Title.GrossWeight') },
      { key: 'volumeWeight', label: this.translateService.instant('DOQuery.Form.Title.VolumeWeight') },
      { key: 'cbm', label: this.translateService.instant('DOQuery.Form.Title.Cbm') },
      { key: 'price', label: this.translateService.instant('DOQuery.Form.Title.Price') }
    ];

    const missingInfo = rows
      .map(r => {
        const miss = checkFields.filter(f => r[f.key] == null).map(f => f.label);
        return miss.length ? { doNo: r.doNo, fields: miss } : null;
      })
      .filter((x): x is { doNo: string, fields: string[] } => x != null);

    this.hasMissing = missingInfo.length > 0;
    if (this.hasMissing) {
      const header = this.translateService.instant('DoMerge.Summary.MissingInfoHeader');
      const lines = missingInfo.map(m =>
        this.translateService.instant('DoMerge.Summary.MissingInfoItem', { doNo: m.doNo, fields: m.fields.join('、') })
      );
      this.missingTooltip = header + '<br>' + lines.join('<br>');
    } else {
      this.missingTooltip = '';
    }
  }

  headerTableTranslation(): DateTableColumn[] {
    var fields: string[];
    var jsons: string[];
    var tmpcolumn: DateTableColumn[] = [];

    fields = ['canMergeStatus', 'bookingNo', 'doNo', 'letterHeadOrgId', 'shipCorp', 'consigneeKey', 'doStatus', 'facility', 'invoiceNo', 'isDropRemark', 'etd', 'deliveryTo', 'shipTo', 'taskCode', 'taskValue', 'deliveryType', 'incoTerm', 'creater', 'sales','assignForwarder'];

    jsons = ['DoMerge.MainTable.CanMergeStatus',
      'DoMerge.MainTable.BookingNo',
      'DoMerge.MainTable.DoNo',
      'DoMerge.MainTable.LetterHeadOrgId',
      'DoMerge.MainTable.ShipCorp',
      'DoMerge.MainTable.ConsigneeKey',
      'DoMerge.MainTable.DoStatus',
      'DoMerge.MainTable.Facility',
      'DoMerge.MainTable.InvoiceNo',
      'DoMerge.MainTable.IsDropRemark',
      'DoMerge.MainTable.ETD',
      'DoMerge.MainTable.DeliveryTo',
      'DoMerge.MainTable.ShipTo',
      'DoMerge.MainTable.TaskCode',
      'DoMerge.MainTable.TaskValue',
      'DoMerge.MainTable.DeliveryType',
      'DoMerge.MainTable.IncoTerm',
      'DoMerge.MainTable.Creater',
      'DoMerge.MainTable.Sales',
      'DoMerge.MainTable.AssignForwarder'
    ];

    for (let i = 0; i < fields.length; i++) {
      if (fields[i] === 'etd') {
        tmpcolumn[i] = ({ field: fields[i], header: jsons[i], dataType: 'date' });
      } else {
        tmpcolumn[i] = ({ field: fields[i], header: jsons[i] });
      }

    }
    return tmpcolumn;
  }

  @Input() get selectedColumns(): DateTableColumn[] {
    return this.selectedTableColumns;
  }

  set selectedColumns(cols: DateTableColumn[]) {
    this.selectedTableColumns = this.dataTableColumns.filter(col => cols.includes(col));
  }

  taskCodeOptionCahange() {
    if (this.editMode) {

      if (!isNullOrEmpty(this.selectedEditRow?.taskCode)) {
        this.selectedEditRow!.taskValue = "Y";
      } else if (isNullOrEmpty(this.selectedEditRow?.taskCode)) {
        this.selectedEditRow!.taskCode = null;
        this.selectedEditRow!.taskValue = null;
      }
    }
  }

  OnRowClick(dataRow: DoMergeSearchResult) {
    this.selectedEditRow = dataRow;
    if (this.editMode) {
      this.headerDoSwitchRow()
    }
  }

  selectOneRowsWithCheckBox(dataRowSelect: any) {
    this.selectedRowsWithCheckBox = dataRowSelect;
  }

  doTaskCodeSaveChange(){
    let mergeDoInfoRequestReq: mergeDoInfoRequest[] = [];

    for (const rowVal of this.results) {
      for (const cloneRowVal of this.cloneTableResults) {
        if (rowVal.doNo == cloneRowVal.doNo) {
          if (JSON.stringify(rowVal) != JSON.stringify(cloneRowVal)) {

            let mergeDoInfoRequestBean = new mergeDoInfoRequest();
            mergeDoInfoRequestBean.doNo = rowVal.doNo!;
            mergeDoInfoRequestBean.taskCode = rowVal.taskCode!;
            mergeDoInfoRequestBean.taskValue = rowVal.taskValue;
            mergeDoInfoRequestBean.createUser = this.userProfile.userName;
            mergeDoInfoRequestBean.updateUser = this.userProfile.userName;
            mergeDoInfoRequestBean.assignForwarder = rowVal.assignForwarder;
            mergeDoInfoRequestReq.push(mergeDoInfoRequestBean);
          }
        }
      }
    }
    this.deliveryOrderService.changeDoTaskCode(mergeDoInfoRequestReq).subscribe({
      next: results => {
        this.isLoading = true;
        this.editMode = false;
        this.table.cancelRowEdit(this.selectedEditRow);
        this.toastService.success(this.translateService.instant('DoMerge.Toast.SaveTaskCodeSuccess'));
      },
      error:response =>{
        let errorCode = response.error.errorCode;
        let category = response.error.category;
        this.commonDataService.getErrorCodes(this.laasSetting.language, category).subscribe({
          next: (errorList) => {
            this.editMode = false;
            this.table.cancelRowEdit(this.selectedEditRow);
            // find error that has the errorCode in  errorList
            let matchedError = errorList.find((error: any) => error.errorCode == errorCode)
            this.toastService.error(matchedError.errorMsg)
            this.editMode = false;
            this.results = this.cloneTableResults;
            this.table.cancelRowEdit(this.selectedEditRow);
          }
        })
      }
      ,
      complete: () => {
        this.table.cancelRowEdit(this.selectedEditRow);
        this.selectedRowsWithCheckBox = [];
        this.resetSummary();
        this.isLoading = false;
        console.log(`before copyFormControl this.serchParams:   ${this.serchParams}`);
        this.serchParams = copyFormControl(this.searchForm, this.serchParams);
        this.isSearchFormOpen = false;
        this.pageInfo.pageIndex = 0;
        this.getMergedDeliveryOrderResults();
      }
    });
  }

  resetTableValue(){
    this.confirmationService.confirm({
      message: this.translateService.instant('AddressMaintain.ConfirmRestore'),
      header: this.translateService.instant('AddressMaintain.SystemInformation'),
      icon: 'pi pi-info-circle',
      accept: () => {
        try {
          this.results = deepCopy(this.cloneTableResults)!;
          this.table.cancelRowEdit(this.selectedEditRow);
          this.editMode = false;
          this.headerChecked = false;
          this.toastService.success(this.translateService.instant('AddressMaintain.Restored'));
        } catch (error) {
          console.log(error);
          this.toastService.error(this.translateService.instant('AddressMaintain.OperationFailed'));
        }
      },
    });
  }

  filterForwarderOptionsByDo(doData: any) {
    this.filterForwarderOptions = this.erpforwarderOptions.filter(forwarder => forwarder.facilityCode == doData.facility).map(forwarder => ({ label: `${forwarder.optionCode} - ${forwarder.commonAttr11}`, value: forwarder.optionCode }));
    this.filterForwarderOptions.unshift({
      label: '-',
      value: ""
    })
  }
}
